import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faComputerSpeaker } from '@fortawesome/pro-duotone-svg-icons';
import { Button } from '../buttons/gradient-btn/button';
import { Notice } from '../notice/notice';

@Component({
  selector: 'andor-media-access-prompt',
  standalone: true,
  imports: [FontAwesomeModule, TranslatePipe, Button, Notice],
  templateUrl: './media-access-prompt.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './media-access-prompt.scss',
})
export class MediaAccessPrompt {
  icon = input(faComputerSpeaker);
  text = input('');

  onRequestAccess = output();

  requestAccess() {
    this.onRequestAccess.emit();
  }
}
